export enum AuditTrailReportReduxTypes {
  AUDIT_TRAIL_REPORT = "@@report/AUDIT_TRAIL_REPORT",
  AUDIT_TRAIL_REPORT_SUCCESS = "@@report/AUDIT_TRAIL_REPORT_SUCCESS",
  AUDIT_TRAIL_REPORT_ERROR = "@@report/AUDIT_TRAIL_REPORT_ERROR",
  RESET_AUDIT_TRAIL_REPORT = "@@report/RESET_AUDIT_TRAIL_REPORT"
}

export type AuditTrailReportPayload = {
  startDate: string;
  endDate: string;
  module?: string | null;
  user?: string | null;
  actionType?: string | null;
  saveReport?: boolean;
};

export type AuditTrailReport = {
  id: string;
  financierId: string;
  userId: string;
  type: string;
  status: number;
  saveReport: boolean;
  fileUrl?: string | null;
  updatedOn: string;
  createdOn: string;
};

export type AuditTrailReportActionDispatch = {
  type: AuditTrailReportReduxTypes.AUDIT_TRAIL_REPORT | AuditTrailReportReduxTypes.RESET_AUDIT_TRAIL_REPORT;
  payload?: AuditTrailReportPayload;
};

export type AuditTrailReportReducerDispatch = {
  type:
    | AuditTrailReportReduxTypes.AUDIT_TRAIL_REPORT
    | AuditTrailReportReduxTypes.AUDIT_TRAIL_REPORT_SUCCESS
    | AuditTrailReportReduxTypes.AUDIT_TRAIL_REPORT_ERROR
    | AuditTrailReportReduxTypes.RESET_AUDIT_TRAIL_REPORT;
  payload: {
    data?: AuditTrailReport;
    error?: string;
  };
};

export type CreateAuditTrailReportRequest = {
  payload: AuditTrailReportPayload;
  type: string;
};

export type AuditTrailReportReduxState = {
  loading?: boolean;
  data?: AuditTrailReport | null;
  error?: string | null;
};
